import { TypographyLogo } from '../../assets/icons';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

const appVersion = process.env.REACT_APP_VERSION || '';

interface Props {
    onClose: () => void;
}

export default function AppVersion(props: Props) {
    const { onClose } = props;

    return (
        <Modal
            size='sm'
            childClassName={styles.wrapper}
            closeFunc={onClose}
        >
            <TypographyLogo width={200} height={52} />
            <span className={styles.text}>
                All rights reserved. &copy; {new Date().getFullYear()} MeritFinder, Inc.
                <br />
                V <code>{appVersion}</code>
            </span>
        </Modal>
    )
}
